import { TitleHuge } from 'Components/Titles';
import { SuccessIcon } from 'img';
import styled from 'styled-components';

import { ContentWrapper } from '../styles';

interface SuccessProps {
    successText?: string;
}

const Success = ({ successText }: SuccessProps) => {
    return (
        <ContentWrapper>
            <Icon>
                <SuccessIcon />
            </Icon>

            <StyledTitleHuge>
                { successText }
            </StyledTitleHuge>
        </ContentWrapper>
    );
};

export default Success;

const Icon = styled.div`
    align-items: center;
    background-color: ${ ({ theme }) => theme.tertiaryBackground };
    border-radius: 50%;
    display: flex;
    height: 60px;
    justify-content: center;
    margin: 0 auto 20px;
    width: 60px;
`;

const StyledTitleHuge = styled(TitleHuge)`
    margin-bottom: ${ ({ theme }) => theme.size.size_10 };
`;
